module.exports = __webpack_public_path__ + "img/woman_color.58c9d5ea.png";